module.exports = __webpack_public_path__ + "img/huawei.13d66c10.png";